import React, { Component } from 'react';
import { Link, NavLink } from "react-router-dom";
import PageWrapper from '../PageWrapper/PageWrapper';

import './Klue.scss';

const About = (props) => {
    window.scrollTo(0, 0)
    return (
        <div class="Klue">
            <PageWrapper>
                <section>
                    <header>
                        <h1>Ex-Klue-sive for Klue customers</h1>
                        <h2><span>Click your Klue Extension for VIP GIF&apos;in</span></h2>
                        <div class="PageWrapper--advert">
                            <Link to="/" class="button">Install The Extension</Link>
                            <img src="/assets/img/browser.001.gif" alt="decor" />
                        </div>
                        
                    </header>
                    <div class="PageWrapper--grid">
                        <div>
                            <h2>If you have it installed... pop-open that Klue Extension for the VIP treatment.</h2>
                            <h3>Take your GIF&apos;in to the next level</h3>
                            <p>100% of all Klue customers who use the Klue Chrome Extension receive access to ex-Klue-sive VIP content and features.</p>
                            <h3>It&apos;s no surprise to the true sales professionals</h3>
                            <p>They are used to the winning that comes with being a happy Klue user.</p>
                            <a href="http://www.klue.com/" class="button">Learn About Klue</a>
                        </div>
                        <div>
                            <h2>Never heard of Klue?</h2>
                            <h2>We&apos;ve never heard of you either. <i>Or have we?</i></h2>
                            <h3>Competitive intelligence that wins business</h3>
                            <p>Klue provides a lens into your competitor’s world, continuously updating and connecting dots to help you win more business.  It’s a new way to capture, manage, and communicate market insights from the web and across the company, in platforms you already use.</p>
                        </div>
                    </div>
                </section>
                <footer>
                    <Link to="/"><img src="/assets/img/abg.logo.001.png" /></Link>
                    <p>&copy; 2020 In hindsight. All rights reserved &mdash; Klue Labs Inc.</p>
                </footer>
            </PageWrapper>
        </div>
    )
}
export default About;